import React ,{ useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import defaultStyles from './dailyBatchHist.module.scss';
import {dailyBatchHistConnected, refreshDailyBatchHist, setGridSorts} from './actions'
import GridHeader from '../../common/gridheader/GridHeader';
import Grid from '../../webcommon/grid/Grid';
import { dailyBatchHistColumns } from './constants';
import { getTimeStamp } from '../../webcommon/common/helpers';
import * as selectors from './selectors'
import { getDefaultSort,getDateFrom, getDateTo, getRows } from './selectors'
import { findGridSort } from "../../common/helpermethods/HelperMethods"
import FilterHeader from '../../webcommon/header/filterheader/FilterHeader';
import { getFilters } from '../../webcommon/header/filterheader/selectors';

const DailyBatchHist = (props)=> {

    const {
        dailyBatchHistConnected,
        rows,
        location        
    } = props;            

    useEffect(() => {
        dailyBatchHistConnected(location.search);
    },[dailyBatchHistConnected, location]);

    
    return (
    <div className={props.styles.wrapper}>
        {/* <div className={props.styles.filter}>                      
                <FilterHeader
                    fixed
                    title="Date Filters"
                    id="DailyBatchHist"/>                                    
            </div> */}
            <div className={props.styles.grid}>
                        <GridHeader
                            title="Daily Batch History"   
                            refreshControlsActive
                            refreshData={ props.refreshDailyBatchHist }  
                            lastUpdated={ props.lastUpdated } />  
                        <div className={ props.styles.separator }>&nbsp;</div>         
                        <Grid
                            sortable
                            columns={dailyBatchHistColumns}
                            rows = { props.rows }
                            loading={ props.loading }
                            defaultSorted={ findGridSort(props.defaultSort, 'timestampSort') }
                            onSortedChange={ (newSorted) => {props.setGridSorts('timestampSort', newSorted);} }
                        />
            </div>                         
        </div>     
        ); 
}
DailyBatchHist.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string
    }).isRequired,
    dailyBatchHistConnected: PropTypes.func.isRequired,
    rows: PropTypes.arrayOf(PropTypes.shape({})),
    styles: PropTypes.objectOf(PropTypes.string)    
};

DailyBatchHist.defaultProps = {
     styles: defaultStyles,
     dateProp: '',
     lastUpdated: getTimeStamp(),
     rows: [],
};

const mapDispatchToProps = {
    dailyBatchHistConnected,
    refreshDailyBatchHist,
    setGridSorts,
};

const mapStateToProps = state => ( 
    {  
        rows: getRows(state),
        loading: state.dailyBatchHist.loadingDailyBatchHist,
        lastUpdated: selectors.getDailyBatchHistLastUpdated(state),
        defaultSort: getDefaultSort(state),
        dateFrom: getDateFrom(getFilters(state, 'DailyBatchHist')),
        dateTo: getDateTo(getFilters(state, 'DailyBatchHist')),
        runDate: getDateFrom(getFilters(state, 'DailyBatchHist')),
    }
)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DailyBatchHist));
